import React from 'react'

import { Route, Switch } from "react-router-dom";
import { withAuthentication } from "../../helpers";
import ErrorBoundary from "../../components/ErrorBoundary";

// Booking
import SearchPage from "../SearchPage";
import FlightsPage from "../FlightsPage";
import ExtraPage from "../ExtraPage";
import SeatsPage from "../SeatsPage";
import CheckoutPage from "../CheckoutPage";
import PaymentPage from "../PaymentPage";
import TdsPaymentPage from "../PaymentPage/tdsPayment";
import ConfirmationPage from "../ConfirmationPage";
import NotFoundPage from "../NotFoundPage";
import DeepLinkRedirectPage from "../DeepLinkRedirectPage";


// WebCheckIn

import CheckInPage from "../WCI";
import WciFlightPage from "../WCI/FlightPage";
import WciPassengerPage from "../WCI/PassengerPage";
import WciSeatsPage from "../WCI/SeatsPage";
import WciConfirmtionPage from "../WCI/ConfirmationPage";

// MMB
import ManagePage from "../MMB";
import MmbSummaryPage from "../MMB/SummaryPage";
import MmbContactPage from "../MMB/ContactPage";
import MmbInfantPage from "../MMB/InfantPage";

// Flight Disruption
import DisruptionPage from "../DisruptionPage";

// Agent
import AgentLoginPage from "../Agent/Login";
import AgentPortalPage from "../Agent/Portal";
import ReportPage from "../Agent/Report";
import AgentManagementPage from "../Agent/Management";
import AgentTopupPage from '../Agent/Topup';
import AgentPassword from "../Agent/Password";
import HelpPage from "../Agent/Help";

// Member
import MemberPortalPage from "../Member/Portal";
import MemberProfilePage from "../Member/Profile";
import MemberActivatePage from "../Member/Activate";
import SigninPage from '../Member/Signin'
import ResetPassword from '../Member/ResetPassword';

// Others
import FeedbackPage from "../FeedbackPage"

import PaymentErrorPage from "../ErrorPage/PaymentError";
import ServiceErrorPage from "../ErrorPage/ServiceError";

import RedirectComponent from "../RedirectComponent";


import PkPassPage from '../PkPassPage'
import ItineraryPkPassPage from '../ItineraryPkPassPage'

// voucher
import PurchasePage from '../Voucher/PurchasePage'
import VoucherConfirmationPage from '../Voucher/ConfirmationPage'
import VoucherRetrievePage from '../Voucher/RetrievePage'


// Booking-funnel steps get their own boundary so a crash on one step
// doesn't take down the whole app chrome, and gives a "back to search"
// recovery instead of a full reload.
function funnelBoundary(Component, name) {
  return props => (
    <ErrorBoundary name={name} homeHref="/search">
      <Component {...props} />
    </ErrorBoundary>
  );
}

export const routes = (
  <Switch>
    <Route exact path="/:lng(en|ar)?" component={RedirectComponent} />
    <Route path="/:lng(en|ar)?/search" render={funnelBoundary(SearchPage, 'SearchPage')} />
    <Route path="/:lng(en|ar)?/flights" render={funnelBoundary(FlightsPage, 'FlightsPage')} />
    <Route path="/:lng(en|ar)?/extra" render={funnelBoundary(ExtraPage, 'ExtraPage')} />
    <Route path="/:lng(en|ar)?/seats" render={funnelBoundary(SeatsPage, 'SeatsPage')}/>
    <Route path="/:lng(en|ar)?/checkout" render={funnelBoundary(CheckoutPage, 'CheckoutPage')}/>
    <Route path="/:lng(en|ar)?/payment" render={funnelBoundary(PaymentPage, 'PaymentPage')} />
    <Route path="/:lng(en|ar)?/tdsPayment" render={funnelBoundary(TdsPaymentPage, 'TdsPaymentPage')} />
    <Route path="/:lng(en|ar)?/confirmation" render={funnelBoundary(ConfirmationPage, 'ConfirmationPage')}/>

    {/* Web Check In */}
    <Route exact path="/:lng(en|ar)?/wci" component={CheckInPage} />
    <Route path="/:lng(en|ar)?/wci/flight" component={WciFlightPage}/>
    <Route path="/:lng(en|ar)?/wci/passenger" component={WciPassengerPage}/>
    <Route path="/:lng(en|ar)?/wci/seats" component={WciSeatsPage}/>
    <Route path="/:lng(en|ar)?/wci/confirmation" component={WciConfirmtionPage}/>

    {/* Manage My Booking  */}
    <Route exact path="/:lng(en|ar)?/mmb" component={ManagePage} />
    <Route path="/:lng(en|ar)?/mmb/summary" component={MmbSummaryPage} />
    <Route path="/:lng(en|ar)?/mmb/contact" component={MmbContactPage} />
    <Route path="/:lng(en|ar)?/mmb/infant" component={MmbInfantPage} />
    

    {/* Flight Disruption */}
    <Route path="/:lng(en|ar)?/disruption" component={DisruptionPage} />

    {/* Travel Agent */}
    <Route exact path="/:lng(en)?/agent" component={AgentLoginPage} />
    <Route path="/:lng(en)?/agent/login" component={AgentLoginPage} />
    <Route path="/:lng(en)?/agent/portal" component={withAuthentication(AgentPortalPage, 'agent')} />
    <Route path="/:lng(en)?/agent/report" component={ withAuthentication(ReportPage, 'agent')} />
    <Route path="/:lng(en)?/agent/manage" component={withAuthentication(AgentManagementPage, 'agent')} />
    <Route path="/:lng(en)?/agent/topup" component={withAuthentication(AgentTopupPage, 'agent')} />
    <Route path="/:lng(en)?/agent/password" component={withAuthentication(AgentPassword, 'agent')} />
    <Route path="/:lng(en)?/agent/help" component={withAuthentication(HelpPage, 'agent')} />

    {/* booking process for agent */}
    <Route path="/:lng(en)?/agent/search" render={funnelBoundary(SearchPage, 'SearchPage')} />
    <Route path="/:lng(en)?/agent/flights" render={funnelBoundary(FlightsPage, 'FlightsPage')} />
    <Route path="/:lng(en)?/agent/extra" render={funnelBoundary(ExtraPage, 'ExtraPage')} />
    <Route path="/:lng(en)?/agent/seats" render={funnelBoundary(SeatsPage, 'SeatsPage')}/>
    <Route path="/:lng(en)?/agent/checkout" render={funnelBoundary(CheckoutPage, 'CheckoutPage')}/>
    <Route path="/:lng(en)?/agent/confirmation" render={funnelBoundary(ConfirmationPage, 'ConfirmationPage')}/>

    {/* wci for agent */}
    <Route exact path="/:lng(en)?/agent/wci" component={CheckInPage} />
    <Route path="/:lng(en)?/agent/wci/flight" component={WciFlightPage}/>
    <Route path="/:lng(en)?/agent/wci/passenger" component={WciPassengerPage}/>
    <Route path="/:lng(en)?/agent/wci/seats" component={WciSeatsPage}/>
    <Route path="/:lng(en)?/agent/wci/confirmation" component={WciConfirmtionPage}/>

    {/* mmb for agent */}
    <Route exact path="/:lng(en)?/agent/mmb" component={ManagePage} />
    <Route path="/:lng(en)?/agent/mmb/summary" component={MmbSummaryPage} />
    <Route path="/:lng(en)?/agent/mmb/contact" component={MmbContactPage} />
    <Route path="/:lng(en)?/agent/mmb/infant" component={MmbInfantPage} />

    {/* flight disruption for agent */}
    <Route path="/:lng(en)?/agent/disruption" component={DisruptionPage} />

    {/* My Portal*/}
    <Route exact path="/:lng(en)?/member" component={SigninPage}/>
    <Route path="/:lng(en)?/member/login" component={SigninPage}/>
    <Route path="/:lng(en)?/member/portal" component={withAuthentication(MemberPortalPage, 'member')}/>
    <Route path="/:lng(en)?/member/profile" component={withAuthentication(MemberProfilePage, 'member')}/>
    <Route path="/:lng(en)?/member/activate" component={MemberActivatePage} />
    <Route path="/:lng(en)?/member/reset-password" component={ResetPassword} />

    <Route exact path="/:lng(en|ar)?/voucher" component={PurchasePage} />
    <Route path="/:lng(en|ar)?/voucher/confirmation" component={VoucherConfirmationPage} />
    <Route path="/:lng(en|ar)?/voucher/retrieve" component={VoucherRetrievePage} />


    <Route path="/feedback" component={FeedbackPage} />
    <Route path="/pkpass" component={PkPassPage} />
    <Route path="/itinerary" component={ItineraryPkPassPage} />

    <Route path="/:lng(en|ar)?/payment-error" component={PaymentErrorPage} />
    <Route path="/:lng(en|ar)?/service-error" component={ServiceErrorPage} />
    <Route path="/index.aspx" component={DeepLinkRedirectPage} />
    <Route component={NotFoundPage} />
  </Switch>
);